// Casing for a trade type name as it is typed.
//
// Sentence case, but decided per keystroke rather than over the whole box:
// only the characters that just went in are cased, by the caps lock state at
// the moment they were typed, and everything already in the box is left as it
// was. So "Pop " then caps lock "PCC" then caps lock off " works" reads
// "Pop PCC works". Recasing the whole string on every change would uppercase
// the lot the moment caps lock went on, and lowercase an initialism again the
// moment it went off.
//
// The first character is always a capital, whatever the caps lock state.
//
// `prev` is the value before the change, `next` the raw value the input
// reports after it. The inserted run is whatever lies between the longest
// common prefix and the longest common suffix of the two, which covers typing,
// pasting and typing over a selection. When the inserted character equals its
// neighbour the split point is ambiguous, but either reading yields the same
// string.
export const caseTypedText = (prev, next, capsLock) => {
  const before = prev || '';
  const after = next || '';
  const max = Math.min(before.length, after.length);
  let head = 0;
  while (head < max && before[head] === after[head]) head += 1;
  let tail = 0;
  while (
    tail < max - head
    && before[before.length - 1 - tail] === after[after.length - 1 - tail]
  ) tail += 1;

  const inserted = after.slice(head, after.length - tail);
  let cased = capsLock ? inserted.toUpperCase() : inserted.toLowerCase();
  // A few characters change length when cased (ß becomes SS). Leave those as
  // typed, so the caller can restore the caret by position.
  if (cased.length !== inserted.length) cased = inserted;

  const out = after.slice(0, head) + cased + after.slice(after.length - tail);
  const first = out.charAt(0).toUpperCase();
  return first.length === 1 ? first + out.slice(1) : out;
};
